import { combineEpics } from 'redux-observable';
import { filtersEpics } from '../features/Filters';
import { orderEpics } from '../features/Order';
import { ordersListEpics } from '../features/OrdersList';

export default combineEpics(filtersEpics, orderEpics, ordersListEpics);
